<template>
	<div class="modal-login-confirm-container flex-col text-center">
		<h5
			class="modal-login-confirm-title text-white font-uppercase"
		>
			{{ $tc('modals.LoginConfirm.title') }}
		</h5>
		<h6 class="modal-login-confirm-body text-white" v-html="$t('modals.LoginConfirm.mainText')" />
		<div class="modal-login-confirm-buttons flex">
			<button class="button-cancel modal-login-confirm-button font-regular font-uppercase text-black mr-5 flex-center" style="padding: 8px 34px;" @click="onClose">
				{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
			</button>
			<nuxt-link
				class="button-light-blue modal-login-confirm-button font-regular font-uppercase text-black ml-5 flex-center"
				:to="{ name: 'auth-index-login', query: { redirectTo: $route.fullPath } }"
				style="padding: 8px 34px;"
			>
				{{ $tc('login.loginButton') }}
			</nuxt-link>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalLoginConfirm',
	mixins: [ModalMixin]
}
</script>

<style lang="scss">
.modal-overlay {
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	transition: 0.5s ease-in-out;
	.modal-login-confirm-container {
		max-width: 319px;
		min-height: 237px;
		width: 100%;
		padding: 25px;
		border-radius: 13px;
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		background-color: rgba(26, 26, 26, 0.95);
		box-shadow: 1px 2px 20px 0 rgba(0, 0, 0, 0.4);
		.modal-login-confirm-body {
			padding: 15px 0 15px 0;
			opacity: 0.7;
		}

		.modal-login-confirm-buttons {
			@include respond-below(phone) {
				flex-direction: column;
			}
			.modal-login-confirm-button {
				@include respond-below(phone) {
					margin: 5px 0 5px 0;
				}
			}
		}
	}
}
</style>
